import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { IGalleryDirectoryItem } from "../../screens/gallery-item/GalleryDirectoryItemController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export const GET_ALL_GALLERY_DIRECTORY_ITEM = (
  pagination: IPagination,
  id: string
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_gallery_directory_item.url +
      `/${id}?perPageRows=${pagination.perPageRows}&currentPage=${pagination.currentPage}&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}`,
    API_ENDPOINTS.get_all_gallery_directory_item.method
  );

export const CREATE_GALLERY_DIRECTORY_ITEM = (
  payload: IGalleryDirectoryItem
) => {
  return serviceMaker(
    API_ENDPOINTS.create_gallery_directory_item.url,
    API_ENDPOINTS.create_gallery_directory_item.method,
    payload
  );
};

export const DELETE_GALLERY_DIRECTORY_ITEM = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_gallery_directory_item.url + `/${id}`,
    API_ENDPOINTS.delete_gallery_directory_item.method
  );
};
